import TemplateNames from '../../email-messages/TemplateNames';

export default {
  title: 'Seneste aktivitet',
  actions: {
    clicked: 'Klikket',
    open: 'Åbnet',
    scheduled: 'Planlagt',
    sent: 'Sendt',
  },
  fields: {
    recipients: '{{recipients}} modtagere',
    opened: '{{rate}} åbnet',
    clicked: '{{rate}} klikket',
    awaiting: 'Afventer bekræftelse',
  },
  template_types: TemplateNames,
};
